function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { List, Typography, Alert } from 'antd';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Receipt = function Receipt(_ref) {
  var options = _ref.options,
    discount = _ref.discount,
    is_pda_active = _ref.is_pda_active,
    serviceTree = _ref.serviceTree,
    _ref$company = _ref.company,
    company = _ref$company === void 0 ? null : _ref$company;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    rdata = _useState2[0],
    setRdata = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    itemsArray = _useState4[0],
    setItemsArray = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedItems = _useState6[0],
    setSelectedItems = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    totalAmount = _useState8[0],
    setTotalAmount = _useState8[1];
  useEffect(function () {
    var optArray = options.toString().split(",");
    var ta = 0;
    serviceTree.forEach(function (d) {
      optArray.forEach(function (o) {
        d.business_account_medical_items.forEach(function (i) {
          if (i.id == o) {
            //HANDLING PRICE CATEGORIES
            if (company == null) {
              setRdata(function (prev) {
                return [].concat(_toConsumableArray(prev), [i.label + " " + i.base_price.toLocaleString('Fr') + " GNF"]);
              });
              //setTotalAmount(prev => parseInt(prev + i.base_price));
              ta += eval(i.base_price);
            } else {
              //ENT PRICE 
              if (company.company_id == null) {
                setRdata(function (prev) {
                  return [].concat(_toConsumableArray(prev), [i.label + " " + (i.ent_price * (1 + company.commercial_rate / 100)).toLocaleString('Fr') + " GNF"]);
                });
                //setTotalAmount(prev => parseInt(prev) + parseInt(i.ent_price));  
                ta += eval(i.ent_price * (1 + company.commercial_rate / 100));
              }
              //INSURANCE PRICE
              if (company.company_id != null && company.company.type == 1) {
                setRdata(function (prev) {
                  return [].concat(_toConsumableArray(prev), [i.label + " " + (i.ins_price * (1 + company.company.commercial_rate / 100)).toLocaleString('Fr') + " GNF"]);
                });
                //setTotalAmount(prev => prev + parseInt(i.ins_price)); 
                ta += eval(i.ins_price * (1 + company.company.commercial_rate / 100));
              }
              /*if(company.company_id!=null && company.company.type==2) {
                  setRdata(prev => [...prev, i.label + " - "+i.lan_price.toLocaleString('Fr') + " GNF"]);
                 // setTotalAmount(prev => prev + parseInt(i.lan_price));  
                 ta += eval(i.lan_price) ; 
              }*/
            }
          }
        });
        setTotalAmount(eval(ta - discount / 100 * ta));
      });
    });
    if (company != null) {
      setTotalAmount(function (prev) {
        return prev * (100 - company.rate) * 0.01;
      });
    }
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(List, {
      header: /*#__PURE__*/_jsx("div", {
        children: "Actes / Produit(s)"
      }),
      footer: /*#__PURE__*/_jsxs("b", {
        children: ["TOTAL GNF ", totalAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")]
      }),
      bordered: true,
      dataSource: rdata,
      renderItem: function renderItem(item) {
        return /*#__PURE__*/_jsx(List.Item, {
          children: /*#__PURE__*/_jsx(Typography.Text, {
            mark: true,
            children: item
          })
        });
      }
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
      children: ["REMISE ", discount, "% ", is_pda_active == 1 && /*#__PURE__*/_jsx("span", {
        style: {
          color: "#8F4F31"
        },
        children: "(*Paiement diff\xE9r\xE9 autoris\xE9)"
      })]
    }), /*#__PURE__*/_jsx("br", {}), company != null && /*#__PURE__*/_jsx(Alert, {
      type: "warning",
      banner: true,
      message: "Prise en charge de " + company.rate.toString() + "% par " + company.label
    })]
  });
};
export default Receipt;